/* eslint-disable react/prop-types */
import React from 'react'
import { MaterialReactTable } from 'material-react-table'
import ExportCsv from '../../Controls/ExportCsv'


export const LocalShowWmsResponseModal = ({ columns, data }) => {
  const filteredColumns = columns.filter((col) =>
    data.some((row) => {
      const hasData = row[col.accessorKey] !== '' && row[col.accessorKey] !== undefined && row[col.accessorKey] !== null
      const hasError = row.errors?.[col.accessorKey] && row.errors[col.accessorKey] !== ''
      return hasData || hasError
    })
  )

  const filteredData = data.filter((row) => row.errors !== undefined)

  return (
    <MaterialReactTable
      columns={filteredColumns}
      data={filteredData}
      enableColumnFilters
      enableRowSelection
      enableExport
      enableGlobalFilter
      enableColumnFilter
      enableColumnSorting
      enableGrouping
      enableColumnResizing
      muiTableHeadCellProps={{
        sx: { color: '#58595B', fontWeight: 'bold' },
      }}
      initialState={{ density: 'compact' }}
      renderTopToolbarCustomActions={({ table }) => {
        const isDisabled = !table.getIsSomeRowsSelected()
        const isNoData = filteredData.length === 0
        const isNoPageData = filteredData.length > 4
        return (
          <ExportCsv
            columns={filteredColumns}
            isDisabled={isDisabled}
            isNoData={isNoData}
            isNoPageData={isNoPageData}
            table={table}
          />
        )
      }}
      tableFor="smart_catalog"
    />
  )
}




